<template>
  <div id="app" class="app">
    <mt-header fixed title="财务报表">
        <router-link to="./cwl" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header>
    <div class="bodyDiv">
      <div class="address">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-date-picker v-model="yearSerch" type="year" placeholder="按年查询" value-format="yyyy"></el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="pageSearch()">查询</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="cwdbTab">
        <div class="cerTop">
          <div class="certit"><span class="kuang"></span>资产负债表</div>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" border>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="1" label="项目" width="180"></el-table-column>
          <el-table-column prop="2" label="本月数"></el-table-column>
          <el-table-column prop="3" label="本年累计数" width="100"></el-table-column>
        </el-table>
      </div>
   
    </div>
  </div>
</template>
<script>
import { cwbbPage,zcfzPage } from "@/api/cwl";
import { doCreate, getDicTab } from "@/utils/config";
export default {
  name: "cwbbinfo",
  data() {
    return {
      year: "",
      sMonth:'01',
      eMonth:'12',
      yearSerch:'',
      xzqhCode: "",
      tableData:[],
    };
  },
  methods: {
    cwbbPage() {
      let url = "/gk/findZcfzb.open?year=" + this.year +"&sMonth="+this.sMonth+"&eMonth="+this.eMonth + "&orgcode=" + this.xzqhCode + "&kmjs=5";
      let _this = this;
      cwbbPage(url).then(res => {
        console.dir(res, 9999);
        let newArr1 = [];
        let newArr2 = [];
        res.data.result.forEach(e => {
          let objj1 = {
            0: e[0],
            1: e[1],
            2: e[2],
            3: e[3]
          };
          let objj2 = {
            0: e[4],
            1: e[5],
            2: e[6],
            3: e[7]
          };
          if(objj1[1]!=''){
            newArr1.push(objj1);
          }
          if(objj2[1]!=''){
            newArr2.push(objj2);
          }
        });
        this.tableData = [...newArr1, ...newArr2];
      });
    },

    //增加时间条件-查询
    pageSearch(){
      console.log(this.yearSerch);
      if(this.yearSerch != ''){
        this.year = this.yearSerch 
      }
      this.cwbbPage()
    },
    
    dicAll() {
        //获取当前年月
        let date = new Date();
        let yearnew = date.getFullYear();
        let month = date.getMonth() + 1;
        if(month < 10){
          // this.month = "0" + "" + month
        }
        this.year = yearnew
    },
  },
  mounted() {
    this.xzqhName = window.sessionStorage.getItem("xzqhName");
    this.xzqhCode = window.sessionStorage.getItem("xzqhCode");
    this.dicAll();
    this.cwbbPage();
  }
};
</script>

<style lang="scss" scoped>
.app {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 40px;
  background: #fff;
  .bodyDiv {
    padding: 0;
    margin: 0;
    flex: 1;
    height: 0;
    overflow: scroll;
  }
  .banner {
    width: 100%;
    height: 160px;
    background: url("../../../public/images/banner.png") no-repeat;
    background-size: 100% 100%;
  }
  .address {
    padding: 10px;
    span {
      display: inline-block;
    }
    .affleft {
      width: 65%;
      padding-right: 10px;
    }
    .addright {
      width: 34%;
    }
  }
  .certent {
    padding: 0 12px 12px 12px;
    background: #fff;
    border-bottom: 10px solid #eee;
    .cerBotjzjd {
      width: 100%;
      height: 100px;
      display: flex;
      border-top: 1px solid #dedede;
      padding: 10px 0 0 0;
      .jzjdMk {
        flex: 1;
        margin: 0 5px;
        padding: 20px 30px;
        line-height: 26px;
        color: #666;
        border-radius: 6px;
        color: #fff;
        .money {
          span {
            font-size: 18px;
          }
        }
      }
      .mk01 {
        background: #f9b248;
      }
      .mk02 {
        background: #4ac537;
      }
      .mk03 {
        background: #42a9f4;
      }
    }
  }
  .cerTop{
    padding: 10px;
    .certit{
      color: #333;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      .kuang{
        width: 6px;
        height: 22px;
        background: #2a8cef;
        display: inline-block;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
  }
  .syfpDiv{
    padding: 10px;
    .table{
      line-height: 24px;
      tr td{
        padding: 0 5px;
      }
    }
  }
}
</style>
<style lang="scss">
.app {
  .mint-header {
    background-color: #2a8cef;
  }
  .mint-header-title {
    font-size: 18px;
  }
  .el-select {
    width: 100%;
  }
  .el-table th{
    background:#ddecff;
    color:#333;
  }
}
</style>
